<template>
    <div>
        <h1 class="font-bold text-4xl mb-10">
            <span class="emoji">☕️</span> Digital Nomad friendly cafes
        </h1>

        <h3 class="text-xl mb-20">Work where <span class="font-bold">you</span> want!</h3>

        <p>
            On this website I've crowdsourced a list of Digital Nomad friendly cafes. This means that the cafe has to
            allow people
            to bring in their laptops and get to work. Some cafes offer free WiFi as well. I hope that this list makes
            it easier for you to pick a
            nice spot to work from and the fact that you can filter the list hopefully helps with that. For example, I
            really like to work in a sunny spot and some cafes offer a few tables in the sun ☀️!
        </p>

        <p class="mt-10">
            The problem with other blogs and sites I found in order to find myself a nice place to work is that most of
            them are outdated or don't
            offer a simple glance at tags like "sunny spot" or "good WiFi", so I decided to crowdsource this data myself
            by visiting random cafes and
            asking other digital nomads for advice! Some places mentioned on other sites have either closed down,
            changed their whole business model
            or don't allow laptops anymore. During my travels around the world, I will do my very best to source spots
            where you can work from in the
            cities that I visit.
        </p>

        <p class="mt-10">
            Look for cafes which are marked as <span class="text-indigo-400 font-bold">(recently) verified</span>, as
            this means that a verified
            digital nomad has visited the cafe
            and confirmed whether it's friendly for digital nomads to work in. In addition to this, they can leave a
            little review or some tips
            about the place! These places are generally the best cafes to work in as a digital nomad if you don't want
            to worry about anything. Do
            you want to become a verified member and help out other digital nomads? Get in touch with me via my Twitter!
        </p>

        <p class="mt-10">
            If you'd like to add a cafe to a city that isn't listed on DigitalNomadCafes.com yet, then you need to add
            the city first. It's easy!
            Just click the button below and add the city to the website.
        </p>
        <p class="mt-20 mb-20">
            <router-link
                class="bg-indigo-400 px-15 py-10 text-white rounded transition-colors hover:bg-pink-500 focus:bg-pink-500"
                to="/cities/add-new">
                Add City
            </router-link>
        </p>

        <div v-for="country in countries" class="mt-20 pt-20 border-t-indigo-400 border-opacity-50 border-t-2">
            <h2 class="font-bold text-3xl mb-20">{{ country.emoji }} {{ country.name }}</h2>

            <div class="flex flex-wrap">
                <div v-for="city in country.cities" class="py-10 px-20">
                    <router-link
                        :to="{name:'countries.cities.show', params: { countrySlug: country.slug, citySlug: city.slug }}"
                        class="bg-clip-text text-2xl bg-gradient-to-r from-indigo-400 to-pink-500 text-clip font-bold hover:underline decoration-pink-500 text-transparent">
                        {{ city.name }}
                    </router-link>
                </div>
            </div>
        </div>

        <p class="mt-20">
            Can't find the city you're looking for?
            <router-link class="text-indigo-400 underline hover:text-pink-500 focus:text-pink-500"
                         to="/cities/add-new">{{ "Add a city" }}
            </router-link>
            yourself and help out other digital nomads, professionals and travelers looking for a place to work from in
            cities around the world.
        </p>
    </div>
</template>

<script>
import {useMeta} from "vue-meta";
import axios from "axios";

export default {
    name: "Index",
    data() {
        return {
            countries: []
        };
    },
    mounted() {
        useMeta({
            title: `Digital Nomad Cafes`,
            og: {
                title: `Digital Nomad Cafes`,
                image: `/api/countries/portugal/cities/lisbon/image`,
                description: 'On this website I\'ve crowdsourced a list of Digital Nomad friendly cafes. This means that the cafe has to allow people\n' +
                    'to bring in their laptops and get to work. Some cafes offer free WiFi as well. I hope that this list makes it easier for you to pick a\n' +
                    'nice spot to work from and the fact that you can filter the list hopefully helps with that. For example, I\n' +
                    ' really like to work in a sunny spot and some cafes offer a few tables in the sun ☀️!'
            }
        });
    },
    methods: {
        getCountries() {
            this.loading = true;

            axios.get(`/api/countries/`).then(response => {
                this.countries = response.data;
            }).catch(error => {
                this.errors = error.response?.data?.errors ?? {};
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    created() {
        this.getCountries();
    }
}
</script>
